import type { CanActivateFn } from '@angular/router';

import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { MICRO_ROUTE_HOST } from '@eliboo/micro-ng/router';

import { TaxUserService } from '../service';
// 白名单
const whiteList: string[] = [];

export function bizChildActivateGuardFn(expired: number) {
  const bizCanActivateFn: CanActivateFn = (route, state) => {
    const userService = inject(TaxUserService);
    const host = inject(MICRO_ROUTE_HOST);
    const router = inject(Router);

    const info = userService.businessLicenseInfoResource.value();
    if (info?.settledRemark?.includes('仅注册用户')) {
      const msg = '用户暂未开通该业务';
      return new RedirectCommand(router.parseUrl(`/tax/result?msg=${msg}`));
    }

    if (userService.getExpiredInfo().isExpired) {
      // Check if we are already on the renewal page to avoid infinite redirect loop
      const currentUrl = state.url;
      // 白名单
      if (whiteList.includes(currentUrl) || userService.getExpiredInfo().expiredDays <= expired) {
        return true;
      }
      if (!currentUrl.includes('main/renewal')) {
        return new RedirectCommand(router.parseUrl(`${host}/main/renewal?isExpired=true`));
      }
    }
    return true;
  };
  return bizCanActivateFn;
}
